import type { GetContractPdfResponse } from '@vy/api-definition';
import { GetContractPdfResponseSchema } from '@vy/api-definition';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';

export function useContractPdf(
  contractId: string,
  options?: CustomUseQueryOptions<GetContractPdfResponse>,
) {
  return useQuery(
    queryKeys.contractPdf(contractId),
    async () => {
      const api = getPrivateApi();
      const response = await api.getContractPdf({ contractId });

      return GetContractPdfResponseSchema.parse(response);
    },
    {
      suspense: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchInterval: false,
      ...options,
    },
  );
}
